import Vue from 'vue'
import VueRouter from 'vue-router'
import { authentication } from '@/js/authentication'
import { Role } from '@/js/roles'

Vue.use(VueRouter)

const routes = [
  // ----------------------------------- SHARED -----------------------------------
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: 'Grupo C&B Propiedades' }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [] }
  },
  {
    path: '/tareas',
    name: 'Tareas',
    component: () => import('../views/tasks/tasks.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [] }
  },

  // ----------------------------------- SHARED -----------------------------------
  {
    path: '/developer',
    name: 'Developer',
    component: () => import('../views/developer/Developer.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [Role.developer] }
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    component: () => import('../views/user/Tutorial.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [Role.developer] }
  },

  // ----------------------------------- LEVANTAMIENTO -----------------------------------

  {
    path: '/propiedades',
    name: 'Propiedades',
    component: () => import('../views/levantamiento/Propiedades.vue'),
    meta: {
      title: 'Grupo C&B Propiedades',
      authorize: [Role.levantador, Role.asistente, Role.jefe, Role.ejecutivo, Role.developer]
    }
  },
  {
    path: '/ficha',
    name: 'Ficha Propiedad',
    props: true,
    component: () => import('../views/levantamiento/Ficha.vue'),
    meta: {
      title: 'Grupo C&B Propiedades',
      authorize: [Role.levantador, Role.asistente, Role.jefe, Role.ejecutivo, Role.developer]
    }
  },
  {
    path: '/load_file',
    name: 'Cargar planilla',
    component: () => import('../views/levantamiento/LoadFile'),
    meta: {
      title: 'Grupo C&B Propiedades',
      authorize: [Role.jefe, Role.asistente, Role.developer]
    }
  },

  // ----------------------------------- USER -----------------------------------

  {
    path: '/perfil',
    name: 'Perfil',
    component: () => import('../views/user/Perfil.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [] }
  },

  // ----------------------------------- ADMIN -----------------------------------
  {
    path: '/administracion/usuarios',
    name: 'Usuarios',
    component: () => import('../views/administrador/Usuarios.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [Role.administrador, Role.developer] }
  },
  {
    path: '/administracion/reasignacion',
    name: 'Reasignacion',
    component: () => import('../views/administrador/Reasignacion.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [Role.jefe, Role.administrador, Role.developer] }
  },
  {
    path: '/administracion/mi_grupo',
    name: 'Mi Grupo',
    component: () => import('../views/administrador/Mi_Grupo.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [Role.jefe, Role.administrador, Role.developer] }
  },
  {
    path: '/administracion/grupos',
    name: 'Grupos',
    component: () => import('../views/administrador/Grupos.vue'),
    meta: { title: 'Grupo C&B Propiedades', authorize: [Role.administrador, Role.developer] }
  },

  // ----------------------- otherwise redirect to login -------------------------
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta
  const currentUser = authentication.currentUserValue

  // console.log('authorize:', authorize)
  // console.log('currentUser:', authentication.currentUser)
  // console.log('currentUserValue:', authentication.currentUserValue)
  // console.log('to:', to)
  // console.log('from:', from)

  if (to.path === '/' && currentUser) {
    authentication.logout()
  }
  if (authorize) {
    if (!currentUser) {
      alert('Primero debes logearte.')
      // not logged in so redirect to login page with the return url
      return next({ path: '/' })
    }
    const user_roles = Object.values(currentUser.roles)
    if (authorize.length > 0 && !authorize.some(v => user_roles.includes(v))) {
      alert('No tienes privilegios suficientes. Comunicate con el administrador.')
      // role not authorised so redirect to home page
      return next(false)
    }
  }
  next()
})

export default router
